var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useResizedImage } from "@brg/ui";
import React, { FC, useMemo } from "react";
import { Endpoints, TFile } from "@brg/api";
import styled from "styled-components";
import { useModal } from "../../../../../core/modules/modal.module";
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 16px 8px 16px 0px;\n"], ["\n    margin: 16px 8px 16px 0px;\n"])));
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    // width: min-content;\n    width: 100%;\n    max-height: fit-content;\n    // cursor: zoom-in;\n"], ["\n    // width: min-content;\n    width: 100%;\n    max-height: fit-content;\n    // cursor: zoom-in;\n"])));
export var CommentImages = function (_a) {
    var attachment = _a.attachment;
    var _b = useResizedImage(attachment === null || attachment === void 0 ? void 0 : attachment.files), imageUrl = _b[0], containerRef = _b[1];
    var baseUrl = Endpoints.files;
    var imgUrl = imageUrl ? "".concat(baseUrl, "/").concat(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) : null;
    var originalImage = useMemo(function () {
        var _a;
        var files = attachment === null || attachment === void 0 ? void 0 : attachment.files;
        var oFile = ((_a = files === null || files === void 0 ? void 0 : files.find(function (i) { return i.size === 'original'; })) === null || _a === void 0 ? void 0 : _a.url) || undefined;
        return "".concat(baseUrl, "/").concat(oFile) || null;
    }, [attachment, imgUrl]);
    //@Нурс еще дизайн не придумал, но функционал работает
    var onZoom = function () {
        modal.show('zoom', { img: originalImage });
    };
    return (React.createElement(Wrapper, { ref: containerRef },
        React.createElement(Image, { src: imgUrl !== null && imgUrl !== void 0 ? imgUrl : '', alt: '' })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=CommentImages.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useResizedImage } from "@brg/ui";
import React, { FC, useMemo } from "react";
import { Endpoints, TFile } from "@brg/api";
import styled from "styled-components";
import { useModal } from "../../../../../core/modules/modal.module";
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 16px 8px 16px 0px;\n"], ["\n    margin: 16px 8px 16px 0px;\n"])));
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    // width: min-content;\n    width: 100%;\n    max-height: fit-content;\n    // cursor: zoom-in;\n"], ["\n    // width: min-content;\n    width: 100%;\n    max-height: fit-content;\n    // cursor: zoom-in;\n"])));
export var CommentImages = function (_a) {
    var attachment = _a.attachment;
    var _b = useResizedImage(attachment === null || attachment === void 0 ? void 0 : attachment.files), imageUrl = _b[0], containerRef = _b[1];
    var baseUrl = Endpoints.files;
    var imgUrl = imageUrl ? "".concat(baseUrl, "/").concat(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.url) : null;
    var originalImage = useMemo(function () {
        var _a;
        var files = attachment === null || attachment === void 0 ? void 0 : attachment.files;
        var oFile = ((_a = files === null || files === void 0 ? void 0 : files.find(function (i) { return i.size === 'original'; })) === null || _a === void 0 ? void 0 : _a.url) || undefined;
        return "".concat(baseUrl, "/").concat(oFile) || null;
    }, [attachment, imgUrl]);
    //@Нурс еще дизайн не придумал, но функционал работает
    var onZoom = function () {
        modal.show('zoom', { img: originalImage });
    };
    return (React.createElement(Wrapper, { ref: containerRef },
        React.createElement(Image, { src: imgUrl !== null && imgUrl !== void 0 ? imgUrl : '', alt: '' })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=CommentImages.js.map